import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Van: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m136.53 360h507.65v30h-507.65z' />
    <path d='m240 540h300v30h-300z' />
    <path d='m225 660h-105v-100h30v70h75c8.27 0 15-6.73 15-15v-55h30v55c0 24.81-20.19 45-45 45z' />
    <path d='m660 660h-105c-24.81 0-45-20.19-45-45v-55h30v55c0 8.27 6.73 15 15 15h75v-70h30z' />
    <path d='m690 420v-90h30v60c0 16.57-13.43 30-30 30z' />
    <path d='m540 480h-300s0-30 0-30h270c16.57 0 30 13.43 30 30z' />
    <path d='m90 420v-90s-30 0-30 0v60c0 16.57 13.43 30 30 30z' />
    <path d='m660 575h-30v-208.8l-29.58-183.48c-.8-1.63-2.58-2.72-4.55-2.72h-410.87c-1.91 0-3.6.99-4.45 2.52l-30.55 183.72v208.76h-30v-211.24l31.43-189 .39-1.16c4.79-14.12 18.13-23.61 33.18-23.61h410.87c15.46 0 28.9 9.82 33.45 24.44l.32 1.02.17 1.05 30.19 187.29v211.2z' />
  </IconBase>
));

Van.displayName = 'Van';

export default Van;
